export default "__VITE_ASSET__4536c97d__"